// src/components/Settings.js
import React from 'react';
import { PageContentWrapper, PageHeader } from '../main/LayoutStyles';
import { StyledButton } from '../main/CommonStyles';
import { SettingsSection } from './SettingsStyles'; // Zaimportuj SettingsSection

const SettingsPage = () => (
    <PageContentWrapper className="custom-scrollbar">
        <PageHeader>Ustawienia Konta</PageHeader>
        <SettingsSection>
            <h3>Profil Użytkownika</h3>
            <p>Zarządzaj swoimi danymi osobowymi.</p>
            <StyledButton onClick={() => console.log("SettingsPage: Edytuj Profil clicked")}>Edytuj Profil</StyledButton>
        </SettingsSection>
        <SettingsSection>
            <h3>Powiadomienia</h3>
            <p>Skonfiguruj preferencje powiadomień.</p>
            <label htmlFor="notifications">
                <input type="checkbox" id="notifications" onChange={(e) => console.log("SettingsPage: Notifications toggled", e.target.checked)} />
                Włącz powiadomienia email
            </label>
        </SettingsSection>
        <SettingsSection>
            <h3>Subskrypcja</h3>
            <p>Zarządzaj swoim planem subskrypcji. (Obecnie: Plan Darmowy)</p>
            <StyledButton
                $secondary // Użyj transient prop
                onClick={() => console.log("SettingsPage: Przejdź na Premium clicked")}
            >
                Przejdź na Premium
            </StyledButton>
        </SettingsSection>
        <SettingsSection>
            <h3>Prywatność i Bezpieczeństwo</h3>
            <p>Zapoznaj się z naszą polityką prywatności i zarządzaj bezpieczeństwem konta.</p>
            <a href="#" onClick={(e) => {e.preventDefault(); console.log("SettingsPage: Polityka Prywatności clicked");}}>Polityka Prywatności</a>
        </SettingsSection>
    </PageContentWrapper>
);

export default SettingsPage;